<template>
  <div class="page bg-white">
    <div class="fixed-top bg-white">
      <div class="checkbox-box">
        <van-checkbox-group
          direction="horizontal"
          class="checkbox-tags text-center"
          v-model="types"
        >
          <van-checkbox
            v-for="(item, index) in $store.state.OrderTypeEnum.list()"
            @click="change()"
            :key="item.value"
            :name="item.value"
            :class="{ checked: types.includes(item.value) }"
            :style="index == 0 ? 'border-left: none' : ''"
          >
            <span slot="icon"></span>
            <span class="checkbox-label">{{ item.label }}</span>
          </van-checkbox>
        </van-checkbox-group>
      </div>
      <div class="checkbox-box" style="margin-bottom: 15px">
        <van-checkbox-group
          direction="horizontal"
          class="checkbox-tags text-center"
          v-model="status"
        >
          <van-checkbox
            v-for="(item, index) in $store.state.OrderStatusEnum.list()"
            @click="change()"
            :key="item.value"
            :name="item.value"
            :class="{ checked: status.includes(item.value) }"
            :style="index == 0 ? 'border-left: none' : ''"
          >
            <span slot="icon"></span>
            <span class="checkbox-label">{{ item.label }}</span>
          </van-checkbox>
        </van-checkbox-group>
      </div>
    </div>

    <van-list
      v-model="loading"
      :finished="listFinished"
      finished-text="没有更多了"
      @load="loadData"
    >
      <van-cell-group class="order-list">
        <van-cell
          v-for="(item, index) in list"
          :key="index"
          size="large"
          center
          clickable
          is-link
          :to="'/clerk/order/detail/' + item.id"
        >
          <div class="order-item">
            <div class="left align-center">
              <div class="user_head">
                <van-image
                  round
                  width="60px"
                  height="60px"
                  :src="
                    !(item.type == 'random' && item.status == -1)
                      ? item.headImgUrl
                      : null
                  "
                >
                </van-image>
                <div
                  class="avatarFrame"
                  v-if="
                    item.avatarFrameUrl &&
                    !item.hideLevelSwitch &&
                    ((item.type == 'assigned' && $ClerkPermission.visibleAssignedOrderUserInfo.includes(UserInfoEnum.AVATAR_FRAME.value))
                    || (item.type == 'random' && item.status != -1 && $ClerkPermission.visibleRandomOrderUserInfo.includes(UserInfoEnum.AVATAR_FRAME.value))
                    || (item.type == 'reward' && $ClerkPermission.visibleRewardOrderUserInfo.includes(UserInfoEnum.AVATAR_FRAME.value)))"
                >
                  <img
                    width="80px"
                    height="80px"
                    :src="
                      (item.type != 'random' || item.status != -1)
                        ? item.avatarFrameUrl
                        : null
                    "
                  />
                </div>

                <template
                  v-if="item.hideLevelSwitch != null && !item.hideLevelSwitch"
                >
                  <van-tag
                    v-if="
                     (item.type == 'assigned' && $ClerkPermission.visibleAssignedOrderUserInfo.includes(UserInfoEnum.LEVEL.value))
                    || (item.type == 'random' && item.status != -1 && $ClerkPermission.visibleRandomOrderUserInfo.includes(UserInfoEnum.LEVEL.value))
                    || (item.type == 'reward' && $ClerkPermission.visibleRewardOrderUserInfo.includes(UserInfoEnum.LEVEL.value))"
                    class="level"
                    round
                    size="medium"
                    type="primary"
                  >
                    {{ item.levelName }}
                  </van-tag>
                </template>
              </div>
              <div class="padding-left-sm">
                <div style="display: inline-block; margin-right: 4px">
                  <van-tag v-if="item.status == 0" type="danger"
                    >待接单</van-tag
                  >
                  <van-tag v-else-if="item.status == 1" color="#ff976a"
                    >待开始</van-tag
                  >
                  <van-tag v-else-if="item.status == 2" type="primary"
                    >服务中</van-tag
                  >
                  <van-tag v-else-if="item.status == 3" type="success"
                    >已完成</van-tag
                  >
                  <van-tag v-else-if="item.status == -1">已取消</van-tag>
                </div>
                <span v-if="!(item.type == 'random' && item.status == -1)">{{
                  item.userName
                }}</span>
                <div>
                  <van-tag v-if="item.type == 'assigned'" type="primary" plain
                    >指定单</van-tag
                  >
                  <van-tag v-if="item.type == 'random'" type="success" plain
                    >随机单</van-tag
                  >
                  <van-tag v-if="item.type == 'reward'" type="danger" plain
                    >打赏单</van-tag>
                  <template v-if="item.isContinued != null">
                    <van-tag style="margin-left: 2px" v-if="item.isContinued" type="primary" plain>续单</van-tag>
                    <van-tag style="margin-left: 2px" v-else type="danger" plain>首单</van-tag>
                  </template>

                  <!--<van-tag v-if="item.type == 'assigned'" plain style="margin-left: 6px;">续单</van-tag>-->
                  <span v-if="item.type != 'reward'">
                    {{
                      item.itemCategory != null
                        ? item.itemCategory.name + "-"
                        : ""
                    }}
                    {{ item.item.names.join("-") }} × {{ item.num }}</span
                  >
                </div>
                <div>
                  <span>{{ formatDate(item.createTime, "MM-DD HH:mm") }}</span>
                </div>
                <div
                  v-if="item.userMemo != null && item.userMemo != ''"
                  class="userMemo"
                >
                  备注：{{ item.userMemo }}
                </div>
              </div>
            </div>
            <div class="right">
              <div class="text-center">
                <div v-if="item.orderFeedBackId">
                  <span style="color: #999999; font-size: 12px">已反馈</span>
                </div>
                <span class="total-amount"
                  >¥{{ formatPrice(item.totalAmount) }}</span
                >
              </div>
            </div>
          </div>
        </van-cell>
      </van-cell-group>
    </van-list>

    <!--上拉选择订单类型-->
    <van-action-sheet
      v-model="orderTypeActionSheet.show"
      :actions="orderTypeActionSheet.actions"
      cancel-text="取消"
      @select="onOrderTypeActionSheetChange"
    />

    <div class="return" @click.stop.prevent="back">
      <van-icon name="arrow-left" size="16px" />
      <div>返回</div>
    </div>

    <div
      v-if="
        $store.state.shop.id != 8 ||
        $store.state.shop.id != 18 ||
        $store.state.shop.id != 37 ||
        $store.state.shop.id != 50 ||
        $store.state.shop.id != 80 ||
        $store.state.shop.id != 1
      "
    >
      <tabbar></tabbar>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Tab,
  Tabs,
  Search,
  Button,
  List,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Tag,
  Icon,
  ActionSheet,
  Dialog,
  Panel,
  Image,
} from "vant";
import { getOrderList } from "@/api/clerk/order";
import moment from "moment";
import Decimal from "decimal.js";
import tabbar from "@/views/clerk/tabbar";

Vue.use(Tab)
  .use(Tabs)
  .use(Search)
  .use(Button)
  .use(List)
  .use(Cell)
  .use(CellGroup)
  .use(Tag)
  .use(Icon)
  .use(ActionSheet)
  .use(Dialog)
  .use(Panel)
  .use(Image)
  .use(Checkbox)
  .use(CheckboxGroup);

export default {
  name: "clerk-order-list",
  components: {
    tabbar,
  },
  data() {
    return {
      ORDER: this.$store.state.order,
      UserInfoEnum: this.$store.state.UserInfoEnum,
      types: [],
      status: [],
      typeShow: false,
      orderType: null,
      orderTypeActionSheet: {
        show: false,
        actions: [],
      },
      list: [],
      loading: false,
      listFinished: false,
      pageNo: 1,
      pageSize: 10,
    };
  },
  methods: {
    change() {
      this.loadData(true);
    },
    formatDate(date, format) {
      if (!date) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD";
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString();
      }
      return "";
    },
    onOrderTypeActionSheetChange(item) {
      this.orderType = item.value;
      this.orderTypeActionSheet.show = false;
      this.loadData(true);
    },
    loadData(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1;
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true;
      getOrderList(
        this.pageNo,
        this.pageSize,
        JSON.stringify(this.types),
        JSON.stringify(this.status)
      ).then((res) => {
        this.loading = false;
        const data = res.data;
        if (data.code == 0) {
          this.list = this.list.concat(data.list);
          if (data.hasNextPage) {
            this.listFinished = false;
          } else {
            this.listFinished = true;
          }
        } else {
          this.listFinished = true;
          Dialog.alert({
            title: "加载失败",
            message: data.msg,
          });
        }
        this.pageNo++;
      });
    },

    back() {
      this.$router.push("/");
    },
  },
  mounted() {
    let orderTypeActions = [
      {
        name: "全部",
        value: null,
      },
    ];
    for (const item of this.$store.state.OrderTypeEnum.list()) {
      orderTypeActions.push({
        name: item.label,
        value: item.value,
      });
    }
    this.orderTypeActionSheet.actions = orderTypeActions;
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
};
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 100px;
}

.fixed-top {
  .toolbar {
    height: 44px;
    font-size: 14px;
    background: #fff;
    position: relative;
    display: flex;

    .tool-item {
      position: relative;
      padding: 12px 0;
      text-align: center;
      flex: 1;
    }
  }
}
.grade-box {
  display: inline-block;
  padding: 3px;
}
.grade-box-y {
  background: #00a7dc;
}
.order-item {
  display: flex;
  align-items: center;

  .userMemo {
    color: #999;
  }

  .left {
    flex: 1;
    display: flex;

    .service-info {
      color: #333;
    }

    .created {
      color: #555;
      margin-bottom: 5px;
    }

    .user_head {
      position: relative;
      padding: 10px;
      .level {
        position: absolute;
        left: 50%;
        height: 12px;
        font-size: 10px;
        white-space: nowrap;
        bottom: 5px;
        transform: translateX(-50%);
      }

      .avatarFrame {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  .right {
    text-align: right;
    min-width: 30px;

    .total-amount {
      color: #333;
    }
  }
}
.checkbox-box {
  padding: 15px 15px 0 15px;
}
.type-title {
  display: inline-block;
  position: relative;
  top: -5px;
  padding-left: 10px;
  color: #999999;
  font-size: 14px;
}
.checkbox-tags,
.radio-service {
  width: 100%;
  box-sizing: border-box;
  display: inline-flex;
  flex-wrap: wrap;
  border-radius: 4px;
  border: 1px solid var(--primary-color);

  /deep/ .van-checkbox,
  /deep/ .van-radio {
    margin-right: 0;
    padding: 0 8px;
    flex: 1;
    box-sizing: border-box;
    height: 25px;
    border-left: 1px solid var(--primary-color);

    .van-radio__label,
    .van-checkbox__label {
      width: 100%;
      font-size: 13px;
      text-align: center;
      margin-left: 0;
      color: var(--primary-color);
    }

    &.checked {
      background: var(--primary-color);
      .van-checkbox__label {
        color: #fff;
      }
    }
  }
}

.return {
  position: fixed;
  bottom: 68px;
  left: 21px;
  display: flex;
  align-items: center;
  border-radius: 50%;
  background: var(--primary-color);
  width: 50px;
  height: 50px;
  color: #fff;
}
</style>
